<template lang="pug">
.analise
  app-relatorio-base(
    titulo="DAEs por período",
    :withTabs="false",
    :filtro="filtroDaePeriodo",
    @gerarGraficos="findDaesPeriodo"
  )
    dae-totais(:totalDaeEmitidos="daesPeriodo.totalDaeSituacao" slot="grafico")
    el-row.rowGrafico(slot="grafico")
      grafico-daes-periodo(
        v-if="daesPeriodo"
        :filtro="filtroDaePeriodo",
        :isMeses="datediff(filtroDaePeriodo.dateRange[0], filtroDaePeriodo.dateRange[1]) > 31",
        :daesPeriodo="daesPeriodo"
      )

</template>

<script>
import AppRelatorioBase from '@/screens/financeiro/relatoriosDae/components/AppRelatorioBase.vue'
import GraficoDaesPeriodo from '@/screens/financeiro/relatoriosDae/components/GraficoDaesPeriodo.vue'
import DaeTotais from '@/screens/financeiro/relatoriosDae/components/DaeTotais.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    AppRelatorioBase,
    GraficoDaesPeriodo,
    DaeTotais
  },

  async created () {
    await this.setDataInicialFiltros()
    this.daesPeriodo = await this.getDaesPeriodo(this.filtroDaePeriodo)
  },

  computed: {
  },

  methods: {
    ...mapActions({
      getDaesPeriodo: 'relatoriosDae/getDaesPeriodo'
    }),

    async findDaesPeriodo () {
      this.setDataFiltros()
      this.daesPeriodo = await this.getDaesPeriodo(this.filtroDaePeriodo)
    },

    datediff (first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24))
    },

    setDataInicialFiltros () {
      this.filtroDaePeriodo.dataFim = new Date()
      this.filtroDaePeriodo.dataInicio = new Date(this.filtroDaePeriodo.dataFim.getUTCFullYear(), (this.filtroDaePeriodo.dataFim.getMonth() - 6) % 12, this.filtroDaePeriodo.dataFim.getDate())

      this.filtroDaePeriodo.dateRange.push(this.filtroDaePeriodo.dataInicio)
      this.filtroDaePeriodo.dateRange.push(new Date())
    },
    setDataFiltros () {
      this.filtroDaePeriodo.dataFim = this.filtroDaePeriodo.dateRange[1]
      this.filtroDaePeriodo.dataInicio = this.filtroDaePeriodo.dateRange[0]
    }
  },

  data () {
    return {
      daesPeriodo: {},
      filtroDaePeriodo: {
        dateRange: [],
        dataInicio: null,
        dataFim: null
      },
      selecionarTodosMunicipios: true,
      timerFuncaoDebounce: null,
      temporizadorDebounce: 1000,
      isLoading: false
    }
  }

}
</script>

<style lang="scss" scoped>

  .tituloGraficos {
    font-size: 25px;
  }
  .rowGrafico {
    padding: 10px;
  }

.empty-div {
  text-align: center;
  padding: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/DaesPeriodo.vue